<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('feng.order')}}</div>
			<div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div>
		</div>
		
		<div class="tab-content" v-if="data">
			<div  class="topWrap">
			    <div  class="topImg">
			        <img :src="data.item?.img" >
			    </div>
			    <div  class="infoBox">
			        <div  class="title">{{data.item?.area}}</div>
			        <div  class="expect">[{{data.ino}}]</div>
			    </div>
			    <div v-if="data.stat==1 && data.zhong>0" class="CgImg">
			       <img src="../images/ban1/enSucc.png" >
			    </div>
				<div v-if="data.stat==1 && data.zhong==0" class="CgImg">
				   <img src="../images/ban1/enError.png" >
				</div>
			</div>
			<div  class="contentWrap">
			    <div  class="items">
			        <div  class="items_left">Status</div>
			        <div  class="items_right">
						<span v-if="data.stat==0" class="padding">Pending</span>
						<span v-if="data.stat==1 && data.zhong>0" class="success">Berhasil</span>
						<span v-if="data.stat==1 && data.zhong==0" class="fail">Gagal</span>
					</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Fasilitas</div>
			        <div  class="items_right notranslate">
						<span v-if="data.da==1">{{data.item?data.item.sda:''}}</span>
						<span v-if="data.xiao==1">{{data.item?data.item.sxiao:''}}</span>
						<span v-if="data.dan==1">{{data.item?data.item.sdan:''}}</span>
						<span v-if="data.shuang==1">{{data.item?data.item.sshuang:''}}</span>
					</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Jenis pesanan</div>
			        <div  class="items_right" v-if="data.stat==0" ></div>
			        <div  class="items_right notranslate" v-if="data.stat==1" >
						<span v-if="data.ida==0">{{data.item?data.item.sda:''}}</span>
						<span v-if="data.ida==1">{{data.item?data.item.sxiao:''}}</span>
						<span v-if="data.idan==0">{{data.item?data.item.sdan:''}}</span>
						<span v-if="data.idan==1">{{data.item?data.item.sshuang:''}}</span>
					</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Waktu</div>
			        <div  class="items_right">{{data.time}}</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Kode pesanan</div>
			        <div  class="items_right">{{16600+data.id}}</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Kategori</div>
			        <div  class="items_right">{{data.item?.area}}</div>
			    </div>
			    <div  class="items">
			        <div  class="items_left">Jumlah Poin</div>
			        <div  class="items_right">{{data.amount}}</div>
			    </div>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "orderdetail",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("order",true);
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			start() {
				Fetch("/user/item_order",{
					id: this.$router.history.current.params.id
				}).then((r) => {
					this.data = r.data;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}
	.contentdz {
		margin: 0 auto;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.contentdz,.contentdz>div {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center
	}

	.contentdz>div {
		font-weight: 600;
		font-size: 14px;
		color: #333;
		width: 70%;
		text-align: left;
		margin-top: 20px
	}

	.contentdz>div div:nth-child(2) {
		margin-left: 20px;
		color: #999
	}
	.tab-content{
		line-height: 20px;
	}
	.detail-item li{
		line-height: 30px;
		display: flex;
		span{
			display: block;
		}
	}
	.topWrap{
	    padding: 11px 24px;
	    position: relative;
	    height: 114px;
	    background: #fff;
	    box-shadow: 0 2px 8px 7px rgba(0,0,0,.06);
	    display: flex;
	    align-items: center;
		.topImg{
		    width: 91px;
		    height: 91px;
		    background: #fff;
		    box-shadow: 0 0 13px 8px rgba(0,0,0,.06);
		    border-radius: 9px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    margin-right: 11px;
			img{
				width: 77px;
				height: 77px;
				border-radius: 50%;
				overflow: hidden;
			}
			
		}
		.CgImg {
		    position: absolute;
		    z-index: 2;
		    bottom: 0;
		    right: 0;
			img{
				width: 91px;
				height: 91px;
			}
		}
		.infoBox{
			padding-left: 10px;
			.title {
			    font-size: 16px;
			    font-weight: 500;
			    color: #333;
			}
			.expect {
			    font-size: 12px;
			    font-weight: 400;
			    color: #333;
				line-height: 30px;
			}
		} 
	}
	.contentWrap{
	    margin: 22px 18px 0;
	    background: #fff;
	    position: relative;
		.items{
		    height: 63px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    border-bottom: 1px solid #e4e4e4;
			.items_left {
			    font-size: 14px;
			    font-weight: 400;
			    color: #666;
			}
			.items_right{
			    font-size: 14px;
			    font-weight: 500;
			    color: #333;
				span{
					margin-right: 20px;
				}
			}
			.padding{
			    font-size: 15px;
			    font-weight: 600;
			    color: #333;
			}
			.error{
			    font-size: 15px;
			    font-weight: 600;
			    color: #fe5443;
			}
			.success {
			    font-size: 15px;
			    font-weight: 600;
			    color: #40e32a;
			}
		}
	}
</style>
